export enum MessageTypesEnum {
  FILE_SIZE = 'FILE_SIZE',
  FILE_FORMATE = 'FILE_FORMATE',
  EXPORT = 'EXPORT',
  EXPORT_DISABLED = 'EXPORT_DISABLED',
  SIMILARITIES_DISABLED = 'SIMILARITIES_DISABLED',
  FILE_UPLOAD = 'FILE_UPLOAD',
  PROSECUTOR_SELECTION = 'PROSECUTOR_SELECTION',
  ADMIN_ERP_CHECKING = 'ADMIN_ERP_CHECKING',
  KNO_SELECTION = 'KNO_SELECTION',
  DELETE_SUCCESS = 'DELETE_SUCCESS',
  PASSWORD_CHANGE = 'PASSWORD_CHANGE',
  KNM_INSPECTORS = 'KNM_INSPECTORS',
  AUTHORIZED_TO_CONDUCT = 'AUTHORIZED_TO_CONDUCT',
  INTERNAL_SERVER = 'INTERNAL_SERVER',
  UPDATE_ADMIN_CATALOG = 'UPDATE_ADMIN_CATALOG',
  CREATE_NEWS = 'CREATE_NEWS',
  UPDATE_NEWS = 'UPDATE_NEWS',
  PASSPORT_SIGN = 'PASSPORT_SIGN',
  GET_TEMPLATES = 'GET_TEMPLATES',
  CREATE_TEMPLATE = 'CREATE_TEMPLATE',
  IMPORT_TEMPLATE = 'IMPORT_TEMPLATE',
  REFRESH_TEMPLATES = 'REFRESH_TEMPLATES',
  UPDATE_TEMPLATE = 'UPDATE_TEMPLATE',
  DELETE_TEMPLATE = 'DELETE_TEMPLATE',
  CHANGE_DEFAULT_TEMPLATE = 'CHANGE_DEFAULT_TEMPLATE',
  DEFAULT_IMPOSSIBLE_TEMPLATE = 'DEFAULT_IMPOSSIBLE_TEMPLATE',
  DEFAULT_TEMPLATE = 'DEFAULT_TEMPLATE',
  SAVE_TEMPLATE_CHANGES = 'SAVE_TEMPLATE_CHANGES',
  CHECKLIST_DUPLICATE_TEMPLATE = 'CHECKLIST_DUPLICATE_TEMPLATE',
  UPDATE_CHECKLIST_TEMPLATE = 'UPDATE_CHECKLIST_TEMPLATE',
  DELETE_CHECKLIST_TEMPLATE = 'DELETE_CHECKLIST_TEMPLATE',
  EXPORT_CHECKLIST = 'EXPORT_CHECKLIST',
  SELECT_CHECKLIST = 'SELECT_CHECKLIST',
  DEFAULT_IMPOSSIBLE_CHECKLIST = 'DEFAULT_IMPOSSIBLE_CHECKLIST',
  DEFAULT_CHECKLIST = 'DEFAULT_CHECKLIST',
  SAVE_CHECKLIST_CHANGES = 'SAVE_CHECKLIST_CHANGES',
  REMOVE_NOTES = 'REMOVE_NOTES',
  SEND_FEEDBACK = 'SEND_FEEDBACK',
  ESIA_AUTHORIZATION = 'ESIA_AUTHORIZATION',
  AUTHORIZATION = 'AUTHORIZATION',
  REGISTER_USER = 'REGISTER_USER',
  CHECK_KNM_BEFORE_SIGN = 'CHECK_KNM_BEFORE_SIGN',
  CHECK_KNM_BEFORE_SIGN_NOT_SAVED = 'CHECK_KNM_BEFORE_SIGN_NOT_SAVED',
  CRIPTOPRO_NOT_EXISTS = 'CRIPTOPRO_NOT_EXISTS',
  UNLIST_KNM = 'UNLIST_KNM',
  SELECT_REQUIREMENT = 'SELECT_REQUIREMENT',
  DELETE_REQUIREMENT = 'DELETE_REQUIREMENT',
  DELETE_SECURITY_QUESTION = 'DELETE_SECURITY_QUESTION',
  KNM_NOT_FOUND = 'KNM_NOT_FOUND',
  DELETE_KNM = 'DELETE_KNM',
  RESTORE_KNM = 'RESTORE_KNM',
  SAVE_KNM = 'SAVE_KNM',
  COPY_KNM = 'COPY_KNM',
  EXPORT_KNM = 'EXPORT_KNM',
  DELETE_KNM_SIGN = 'DELETE_KNM_SIGN',
  DOWNLOAD_XML = 'DOWNLOAD_XML',
  DOWNLOAD_KNM_ZIP = 'DOWNLOAD_KNM_ZIP',
  UPLOAD_SIGN = 'UPLOAD_SIGN',
  VALIDATION_PM_SIGN = 'VALIDATION_PM_SIGN',
  REJECT_KNM_REASONS = 'REJECT_KNM_REASONS',
  KNM_LINK = 'KNM_LINK',
  KNM_FILE_SIZE = 'KNM_FILE_SIZE',
  KNM_NOT_AVAILABLE_FOR_PUBLISH = 'KNM_NOT_AVAILABLE_FOR_PUBLISH',
  CREATE_PLAN_KNM = 'CREATE_PLAN_KNM',
  ADD_KNM_TO_PLAN = 'ADD_KNM_TO_PLAN',
  ADMIN_SETTINGS_UPDATE = 'ADMIN_SETTINGS_UPDATE',
  UPDATE_PLAN_STATUSES = 'UPDATE_PLAN_STATUSES',
  VALIDATE_DOCUMENT = 'VALIDATE_DOCUMENT',
  UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT',
  MISSING_PROSECUTOR_DOCS = 'MISSING_PROSECUTOR_DOCS',
  MISSING_PLAN_KNMS = 'MISSING_PLAN_KNMS',
  SIGN_PLAN = 'SIGN_PLAN',
  SIGN_PLAN_WARNING = 'SIGN_PLAN_WARNING',
  SIGN_UPLOAD_PLAN = 'SIGN_UPLOAD_PLAN',
  APPROVED_KNM = 'APPROVED_KNM',
  KNM_PLAN_NOT_AVAILABLE_TO_ADJUSTMENT = 'KNM_PLAN_NOT_AVAILABLE_TO_ADJUSTMENT',
  NEW_PLAN_STATUS_WITH_DISAPPROVED_KNMS = 'NEW_PLAN_STATUS_WITH_DISAPPROVED_KNMS',
  VALIDATE_DOCUMENT_TYPE = 'VALIDATE_DOCUMENT_TYPE',
  CHANGE_STATUS_TIME_IS_OUT = 'CHANGE_STATUS_TIME_IS_OUT',
  PLAN_SAVE_ERROR = 'PLAN_SAVE_ERROR',
  PLAN_UPDATE_STATUS = 'PLAN_UPDATE_STATUS',
  PLAN_IS_EMPTY = 'PLAN_IS_EMPTY',
  COMMENT_KNM = 'COMMENT_KNM',
  EXCLUDE_KNM = 'EXCLUDE_KNM',
  APPROVE_KNM = 'APPROVE_KNM',
  PLAN_CHANGE_KNO = 'PLAN_CHANGE_KNO',
  SMEV_MONITORING = 'SMEV_MONITORING',
  KNM_EDIT_RESTRICTION_ENABLED_WAITING_OTHER = 'KNM_EDIT_RESTRICTION_ENABLED_WAITING_OTHER',
  KNM_EDIT_RESTRICTION_WAITING_ENABLE = 'KNM_EDIT_RESTRICTION_WAITING_ENABLE',
  KNM_EDIT_RESTRICTION_GET_ERROR = 'KNM_EDIT_RESTRICTION_GET_ERROR',
  KNM_EDITORS = 'KNM_EDITORS',
  KNM_ATTACH_WEB_DOCUMENT = 'KNM_ATTACH_WEB_DOCUMENT',
  KNM_SIGNED_INVALID = 'KNM_SIGNED_INVALID',
  KNM_COMPLETE_336 = 'KNM_COMPLETE_336',
  KNM_MESSAGE_BY_STATUS = 'KNM_MESSAGE_BY_STATUS',
  KNM_FETCH_EXCLUDED_DATES = 'KNM_FETCH_EXCLUDED_DATES',
  KNM_FETCH_WORKING_DAYS_COUNT = 'KNM_FETCH_WORKING_DAYS_COUNT',
  CHECKING_IT_ACCREDITATION = 'CHECKING_IT_ACCREDITATION',
  CHECKING_IN_REGESTRY_ORDER = 'CHECKING_IN_REGESTRY_ORDER',
  ADMIN_ADD_SYSTEM_INOPERABILITY_RECORD = 'ADMIN_ADD_SYSTEM_INOPERABILITY_RECORD',
  KNM_FETCH_PLANNED_ACTIVITIES = 'KNM_FETCH_PLANNED_ACTIVITIES',
  KNM_FETCH_NK_FOREIGN_AGENT_BY_OGRN = 'KNM_FETCH_NK_FOREIGN_AGENT_BY_OGRN',
  REQUIREMENTS_NPA = 'REQUIREMENTS_NPA',
  CREATE_SU_ERROR = 'CREATE_SU_ERROR',
  KNM_FETCH_IS_ORG_IN_SONKO_REGISTRY = 'KNM_FETCH_IS_ORG_IN_SONKO_REGISTRY',
  ADMIN_KIND_KNM = 'ADMIN_KIND_KNM',
  NOT_HAVE_HIGHT_RISK = 'NOT_HAVE_HIGHT_RISK',
  GET_KNO_SUPERVISION = 'GET_KNO_SUPERVISION',
  CHANGE_KNO = 'CHANGE_KNO',
  KNM_CHECK_CHANGES = 'KNM_CHECK_CHANGES',
  LK_ACCOUNT_CHANGE = 'LK_ACCOUNT_CHANGE',
  ERKNM_GET_EVENT_TYPES = 'ERKNM_GET_EVENT_TYPES',
  ACT_ERRORS = 'ACT_ERRORS',
  SAVE_BEFORE_SIGN = 'SAVE_BEFORE_SIGN',
  NPA_CHECK = 'NPA_CHECK',
  ERVK_OBJECTS = 'ERVK_OBJECTS',
  ERKNM_LINKS = 'ERKNM_LINKS',
  PASSPORT_GROUP = 'PASSPORT_GROUP',
  CREATE_PM = 'CREATE_PM',
  PRESCRIBE_CANCEL = 'PRESCRIBE_CANCEL',
  HAS_GET_DATA_ERROR = 'HAS_GET_DATA_ERROR',
}
